import { Component } from 'react'
import store from '../store'
import { hashHistory } from 'react-router'

export default class extends Component {
  componentDidMount() {
    this.check()
  }

  // type  1是公共版 2是专享版
  // status  1是已开通  2是已过期
  // auth_status 1是已授权 没有或者其他值是未授权
  check = async () => {
    const replace = hashHistory.push
    const { auth_status, status, type } = await store.replaceHash()

    if (!type) {
      replace('/localMerchant/liteApp/intro')
      return
    }

    if (type == '1') {
      replace('/localMerchant/liteApp/manage')
    } else {
      if (status == '2') {
        if (auth_status == '1') {
          replace('/localMerchant/liteApp/manage')
        } else {
          replace('/localMerchant/liteApp/authorize')
        }
      } else {
        if (auth_status == '0' || auth_status == '2') {
          replace('/localMerchant/liteApp/authorize')
        } else {
          replace('/localMerchant/liteApp/manage')
        }
      }
    }
  }

  render() {
    return null
  }
}
